import * as React from 'react';
export const SVGComponent = (props) => (
  <svg
    height={16}
    viewBox='0 0 19.087 40.264'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M104.223,3.72a3.424,3.424,0,1,1-3.42,3.427A3.43,3.43,0,0,1,104.223,3.72ZM109.017,42.2a1.792,1.792,0,0,1-3.584,0V31.1c0-.907.139-2.305-1.209-2.305s-1.2,1.4-1.2,2.305V42.2a1.792,1.792,0,0,1-3.584,0V17.95a.715.715,0,0,0-1.43,0v9.575a1.663,1.663,0,0,1-3.326,0V18.687c0-3.521,1.575-6.74,5.512-6.74h1.493l2.539,3.584,2.539-3.584h1.493c3.937,0,5.512,3.219,5.512,6.74v8.838a1.663,1.663,0,0,1-3.326,0V17.95a.715.715,0,0,0-1.43-.019V42.2Z'
      data-name='Path 4380'
      fill='#007e75'
      id='Path_4380'
      transform='translate(-94.68 -3.72)'
    />
  </svg>
);
